import { render, staticRenderFns } from "./AdminLanguage.vue?vue&type=template&id=31fc0996&scoped=true"
import script from "./AdminLanguage.vue?vue&type=script&lang=ts"
export * from "./AdminLanguage.vue?vue&type=script&lang=ts"
import style0 from "./AdminLanguage.vue?vue&type=style&index=0&id=31fc0996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fc0996",
  null
  
)

export default component.exports